/**
 * ①添
 * @@新增 定义初始化菜单
 */

import {
  setMenuRender,
  getMenuRender,
  setSubMenu
} from '@/libs/util'
import store from '@/store'
import {
  lazyLoadingCop
} from '@/libs/tools'
import {getMenuRenders} from '@/api/api-menuRender';
const Layout =()=> import('@/view/layout');
import parentView from '@/components/parent-view' 
import common from "@/libs/common";// parentView 是二级架构组件，不在后台返回，在文件里单独引入
// const _import = require('@/router/_import_' + process.env.NODE_ENV)// 获取组件的方法

var gotRouter
// 初始化路由
export const initRouter = () => {
  debugger
  let antRouter = getMenuRender()
  if (!antRouter) {
    getMenuRenders().then(res => {
      let policies = res.auth.policies; // 所有权限
      let grantedPolicies = res.auth.grantedPolicies; // 现有权限
      let permissGroup = [];
      for (let key of Object.keys(grantedPolicies)) {
        if(key.indexOf('Intelligent') > -1&&key.split('.').length==2){
          permissGroup = [...permissGroup,key]
        }
      }
      // permissGroup = [
      //       // "Intelligent.ProductABC",
      //       "Intelligent.DispatchCenter",
      //       "Intelligent.PriceAnalysis",
      //       "Intelligent.TimeSaleAnalysis",
      //       "Intelligent.DataBrain"]
      var routerData = getStyleRouter(permissGroup)
      console.log("routerData",routerData)
      setMenuRender(JSON.stringify(routerData)) // 存储路由到localStorage
      gotRouter = filterAsyncRouter(routerData) // 过滤路由,路由组件转换
      store.commit('updateMenuList', gotRouter)
      dynamicRouterAdd()
      // let subMenu = getSubMenus(permissGroup, "")
      // setSubMenu(JSON.stringify(subMenu)) // 存储路由到localStorage
    })
  } else {
    gotRouter = dynamicRouterAdd()
  }
  return gotRouter
}
// 格式化路由存储格式
export const getSubMenus = (subMenu, paths) => {
  let sub = subMenu.map(item => {
    item["paths"] = `${paths}_${item.name}`
    if (item.subMenu && item.subMenu.length) {
      item.subMenu = getSubMenus(item.subMenu, item["paths"])
    }
    return item
  })
  return sub
}
// 获取路由格式
export const getStyleRouter = (routerData) => {
  let children = routerData.map(item => {
    return common.menuMainRouter.filter(opt=>item==opt.key)[0]||null
  }).filter(item=>item!=null)
  let routers = [
    {
      path: `/`,
      component: 'Layout',
      children: children
    }
  ]
  
  if(routerData.filter(item=>item==common.menuOtherRouter[0].key).length>0){
    routers = [...routers,...common.menuOtherRouter]
  }
  return routers
}
// 加载路由菜单,从localStorage拿到路由,在创建路由时使用
export const dynamicRouterAdd = () => {
  let dynamicRouter = []
  let data = getMenuRender()
  if (!data) {
    return dynamicRouter
  }
  dynamicRouter = filterAsyncRouter(JSON.parse(data))
  return dynamicRouter
}

// @函数: 遍历后台传来的路由字符串，转换为组件对象
export const filterAsyncRouter = (asyncRouterMap) => {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component) {
      if (route.component === 'Layout') { // Main组件特殊处理
        route.component = Layout
      } else if (route.component === 'parentView') { // parentView组件特殊处理
        route.component = parentView
      } else {
        route.component = lazyLoadingCop(route.component)
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })
  // console.log('accessedRouters::', accessedRouters)
  return accessedRouters
}



// WEBPACK FOOTER //
// ./src/libs/router-util.js